import React, {ReactElement} from 'react';
import {IElementArrowV2} from '../../../../incase-domain/elements/shapes/arrowV2';
import usePresScale from '../../../../util/usePresScale';
import {asymptoticScale} from '../../../../utils/utils';

interface ElementLineComponentV2Props {
    element: IElementArrowV2;
}

function ArrowElementV2({element}: ElementLineComponentV2Props): ReactElement {
    const {color, size, startPoint, endPoint} = element;
    const strokeColor = color || 'black';
    const strokeWidth = size || 0.0625;
    const {transformPointFromFraction} = usePresScale();

    const stratPointTransformed = transformPointFromFraction(startPoint);
    const endPointTransformed = transformPointFromFraction(endPoint);

    const markerScale = asymptoticScale(strokeWidth, 1, 5, 2);
    const markerSize = 14 * markerScale;
    const polylinePoints = `0,0 ${markerSize},${markerSize / 2} 0,${markerSize}`;

    return (
        <svg style={{height: '100%', width: '100%'}}>
            <defs>
                <marker
                    id="arrowhead"
                    markerWidth={markerSize}
                    markerHeight={markerSize}
                    refX={markerSize}
                    refY={markerSize / 2}
                    orient="auto"
                    markerUnits="userSpaceOnUse"
                >
                    <polyline points={polylinePoints} fill="none" stroke={strokeColor} strokeWidth={`${strokeWidth}em`} />
                </marker>
            </defs>

            <line
                x1={stratPointTransformed.x}
                y1={stratPointTransformed.y}
                x2={endPointTransformed.x}
                y2={endPointTransformed.y}
                stroke={strokeColor}
                strokeWidth={`${strokeWidth}em`}
                markerEnd="url(#arrowhead)"
            />
        </svg>
    );
}

export default ArrowElementV2;
